<div class="card-product -title">
  <icon *ngIf="icon" [icon]="icon"></icon>
  <h3>{{title}}</h3>
</div>
<ng-content></ng-content>